import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Home from './views/Home.vue'
import Impact from './views/Impact'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'home', component: Home, query: { id_site: null, id_link: null } },
    { path: '/impact', name: 'impact', component: Impact, query: { id_site: null, id_link: null } },
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('init').then(() => {
    next()
  }).catch((error) => {
    // eslint-disable-next-line
    console.error("beforeEach error: ", error)
  })
})

export default router
